import {
  ENotificationFilterCategory,
  ENotificationType,
  NOTIFICATION_CATEGORY_TYPES
} from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  value?: ENotificationFilterCategory;
  onChange: (value: ENotificationFilterCategory, types?: ENotificationType[]) => void;
  allowClear?: boolean;
  placeholder?: string;
};

const FILTER_OPTIONS: { value: ENotificationFilterCategory; labelKey: string }[] = [
  { value: ENotificationFilterCategory.ALL, labelKey: 'ALL_NOTIFICATIONS_FILTER' },
  { value: ENotificationFilterCategory.EVENTS, labelKey: 'NEW_EVENT_FILTER' },
  { value: ENotificationFilterCategory.POSTS, labelKey: 'NEW_POST_FILTER' },
  { value: ENotificationFilterCategory.TICKETS, labelKey: 'NEW_TICKET_FILTER' }
];

export const NotificationTypeSelect: React.FC<Props> = ({
  value,
  onChange,
  allowClear = false,
  placeholder
}) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return FILTER_OPTIONS.map(option => ({
      label: t(option.labelKey),
      value: option.value
    }));
  }, [t]);

  const handleChange = (selectedValue: ENotificationFilterCategory) => {
    const types = NOTIFICATION_CATEGORY_TYPES[selectedValue];
    onChange(selectedValue, types);
  };

  return (
    <Select
      options={options}
      onChange={handleChange}
      value={value}
      allowClear={allowClear}
      placeholder={placeholder}
      style={{ minWidth: '150px' }}
    />
  );
};
